import { useQuery } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { EdgeStack, StatusType } from '@/react/edge/edge-stacks/types';
import { withError } from '@/react-tools/react-query';

import { EdgeUpdateResponse, EdgeUpdateSchedule } from '../types';

import { queryKeys } from './query-keys';
import { buildUrl } from './urls';

export function useItem(
  id: EdgeUpdateSchedule['id'],
  {
    select,
    refetchInterval,
  }: {
    select?: (stacks: EdgeUpdateListItemResponse) => EdgeUpdateListItemResponse;
    refetchInterval?:
      | number
      | false
      | ((data?: EdgeUpdateListItemResponse) => false | number);
  } = {}
) {
  return useQuery(queryKeys.item(id), () => getItem(id), {
    ...withError('Failed loading update schedule'),
    select,
    refetchInterval,
  });
}

export type EdgeUpdateListItemResponse = EdgeUpdateResponse & {
  edgeStack?: EdgeStack;
  aggregatedStatus: Partial<Record<StatusType, number>>;
  statusMessage: string;
  isActive: boolean;
};

async function getItem(id: EdgeUpdateListItemResponse['id']) {
  try {
    const { data } = await axios.get<EdgeUpdateListItemResponse>(buildUrl(id), {
      params: { includeEdgeStack: true },
    });
    return data;
  } catch (err) {
    throw parseAxiosError(
      err as Error,
      'Failed to get list of edge update schedules'
    );
  }
}
